import React, { useEffect } from 'react'
import { Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { EdgeShell } from '../components/SideNav/EdgeShell'

export function PageNotFound() {
  const navigate = useNavigate()

  useEffect(() => {
    window.onpopstate = () => {
      if (navigate.length > 1) {
        navigate(-2)
      } else {
        navigate('')
      }
    }

    return () => {
      window.onpopstate = () => {}
    }
  }, [])

  return (
    <EdgeShell>
      <Stack width={1} height={1} minHeight="50vh" alignItems="center" justifyContent="center">
        <Typography color="primary" variant="h3">
          Page not found
        </Typography>
        <Typography color="primary" variant="h1" fontWeight="bold">
          404
        </Typography>
      </Stack>
    </EdgeShell>
  )
}
